import { render, staticRenderFns } from "./transfer-select.vue?vue&type=template&id=0a7d66e0"
import script from "./transfer-select.vue?vue&type=script&lang=js"
export * from "./transfer-select.vue?vue&type=script&lang=js"
import style0 from "./transfer-select.vue?vue&type=style&index=0&id=0a7d66e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports